import React, { useEffect, useState } from "react";
import api from "../../api";
import axios from "axios";
import {
  Backdrop,
  Chip,
  CircularProgress,
  MenuItem,
  Snackbar,
  TextField,
  Typography
} from "@material-ui/core";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  ListGroup,
  ListGroupItem,
  Row
} from "shards-react";
import { Autocomplete } from "@material-ui/lab";
import NumberFormat from "react-number-format";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const statuses = [
  { value: "draft", label: "Borrador" },
  { value: "published", label: "Publicada" },
  { value: "archived", label: "Archivada" }
];

const statusLabel = value => {
  const match = statuses.find(option => option.value === value);
  return match ? match.label : value || "";
};

const unwrap = data => {
  if (data && Object.prototype.hasOwnProperty.call(data, "data")) {
    return data.data;
  }
  return data;
};

const dateInput = value => (value ? String(value).slice(0, 10) : "");

const formatDate = value => {
  if (!value) return "Sin fecha";
  const parts = String(value).slice(0, 10).split("-");
  if (parts.length !== 3) return value;
  return parts[2] + "/" + parts[1] + "/" + parts[0];
};

const fieldLabelProps = { style: { fontSize: "0.75rem" } };
const fieldInputProps = { style: { fontSize: "0.75rem" } };

const MoneyField = ({ id, label, value, onChange }) => (
  <NumberFormat
    id={id}
    variant="outlined"
    fullWidth
    margin="dense"
    label={label}
    value={value}
    onValueChange={values => onChange(values.value)}
    thousandSeparator="."
    decimalSeparator=","
    prefix="$ "
    customInput={TextField}
    InputLabelProps={fieldLabelProps}
    InputProps={fieldInputProps}
  />
);

const toNumber = value => {
  if (value === "" || value === null || value === undefined) return null;
  const number = Number(value);
  return Number.isNaN(number) ? null : number;
};

const versionLabel = version => {
  if (!version) return "";
  if (version.full_name) return version.full_name;
  const variation = version.variation || {};
  const brand = variation.brand ? variation.brand.name : "";
  return [brand, variation.model_description, version.name]
    .filter(Boolean)
    .join(" ");
};

const emptyItem = () => ({
  key: "tmp-" + Date.now() + "-" + Math.random(),
  id: null,
  label: "",
  km_included_monthly: "",
  km_excess_price: "",
  price_new_monthly: "",
  price_new_min: "",
  price_used_monthly: "",
  price_used_min: "",
  versions: []
});

const mapItem = item => ({
  key: "item-" + item.id,
  id: item.id,
  label: item.label || "",
  km_included_monthly:
    item.km_included_monthly != null ? item.km_included_monthly : "",
  km_excess_price: item.km_excess_price != null ? item.km_excess_price : "",
  price_new_monthly:
    item.price_new_monthly != null ? item.price_new_monthly : "",
  price_new_min: item.price_new_min != null ? item.price_new_min : "",
  price_used_monthly:
    item.price_used_monthly != null ? item.price_used_monthly : "",
  price_used_min: item.price_used_min != null ? item.price_used_min : "",
  versions: (item.versions || []).map(link => {
    const version = link.version || null;
    const versionId = link.version_id || (version && version.id);
    return {
      id: link.id,
      version_id: versionId,
      label: versionLabel(version) || String(versionId || "")
    };
  })
});

const FlexPriceList = ({ match }) => {
  const rawId = match && match.params ? match.params.id : null;
  const id = rawId ? rawId : 0;
  const [list, setList] = useState({
    id: 0,
    name: "",
    status: "draft",
    valid_from: "",
    valid_to: "",
    adjustment_pct: "",
    used_max_year: "",
    notes: "",
    items: [emptyItem()]
  });
  const [loading, setLoading] = useState(id != 0);
  const [versions, setVersions] = useState({ options: [], loading: false });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const [backdrop, setBackdrop] = useState({ open: false, message: "" });

  const getList = listId => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.flexPriceLists().get(listId), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        const data = unwrap(res.data);
        setList({
          id: data.id,
          name: data.name || "",
          status: data.status || "draft",
          valid_from: dateInput(data.valid_from),
          valid_to: dateInput(data.valid_to),
          adjustment_pct:
            data.adjustment_pct != null ? data.adjustment_pct : "",
          used_max_year: data.used_max_year != null ? data.used_max_year : "",
          notes: data.notes || "",
          items: (data.items || []).map(mapItem)
        });
        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
        setSnackbar({
          open: true,
          message: "No se pudo cargar la lista",
          severity: "error"
        });
      });
  };

  useEffect(() => {
    if (id != 0) {
      getList(id);
    }
  }, [id]);

  const updateItem = (index, field, value) => {
    setList(prev => {
      const items = prev.items.slice();
      items[index] = { ...items[index], [field]: value };
      return { ...prev, items };
    });
  };

  const handleSearchVersions = (event, value) => {
    const token = localStorage.getItem("userToken");
    if (!value || value.length < 3) return;
    setVersions({ options: [], loading: true });
    axios
      .get(api.versions().autocomplete(value), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        setVersions({
          options: res.data || [],
          loading: false
        });
      })
      .catch(err => {
        console.log(err);
        setVersions({ options: [], loading: false });
      });
  };

  const addVersion = (index, option) => {
    if (!option || !option.id) return;
    const label = option.full_name || versionLabel(option);
    const duplicated = list.items.some(item =>
      item.versions.some(version => version.version_id === option.id)
    );
    if (duplicated) {
      setSnackbar({
        open: true,
        message: "La versión " + label + " está repetida en la lista.",
        severity: "error"
      });
      return;
    }
    setList(prev => {
      const items = prev.items.slice();
      items[index] = {
        ...items[index],
        versions: items[index].versions.concat({
          version_id: option.id,
          label: label
        })
      };
      return { ...prev, items };
    });
  };

  const removeVersion = (index, versionId) => {
    setList(prev => {
      const items = prev.items.slice();
      items[index] = {
        ...items[index],
        versions: items[index].versions.filter(
          version => version.version_id !== versionId
        )
      };
      return { ...prev, items };
    });
  };

  const itemHasContent = item =>
    item.id ||
    item.label ||
    item.km_included_monthly !== "" ||
    item.km_excess_price !== "" ||
    item.price_new_monthly !== "" ||
    item.price_new_min !== "" ||
    item.price_used_monthly !== "" ||
    item.price_used_min !== "" ||
    item.versions.length > 0;

  const validatePayload = items => {
    if (id == 0 && !list.name) return "Ingresá un nombre";
    if (list.name && list.name.length > 191) {
      return "El nombre no puede superar 191 caracteres";
    }
    if (id == 0 && !list.valid_from) return "Ingresá la fecha desde";
    if (
      list.valid_from &&
      list.valid_to &&
      list.valid_to < list.valid_from
    ) {
      return "La fecha hasta no puede ser anterior a la fecha desde.";
    }
    if (list.used_max_year !== "" && list.used_max_year != null) {
      const year = Number(list.used_max_year);
      if (!Number.isInteger(year) || year < 1900 || year > 2100) {
        return "El año máximo usado debe ser un entero entre 1900 y 2100";
      }
    }
    if (
      list.adjustment_pct !== "" &&
      list.adjustment_pct != null &&
      Number.isNaN(Number(list.adjustment_pct))
    ) {
      return "El ajuste debe ser numérico";
    }

    const seen = {};
    for (let index = 0; index < items.length; index++) {
      const item = items[index];
      const position = index + 1;
      if (item.label && item.label.length > 191) {
        return (
          "La etiqueta del ítem " + position + " no puede superar 191 caracteres"
        );
      }
      const km = toNumber(item.km_included_monthly);
      if (km === null || !Number.isInteger(km) || km < 0) {
        return "El ítem " + position + " necesita kilómetros incluidos enteros";
      }
      const excess = toNumber(item.km_excess_price);
      if (excess === null || excess < 0) {
        return "El ítem " + position + " necesita el precio de km extra";
      }
      const priceNew = toNumber(item.price_new_monthly);
      if (priceNew === null || priceNew < 0) {
        return "El ítem " + position + " necesita el precio 0 km";
      }
      const priceNewMin = toNumber(item.price_new_min);
      if (priceNewMin === null || priceNewMin < 0) {
        return "El ítem " + position + " necesita el mínimo 0 km";
      }
      if (priceNewMin > priceNew) {
        return (
          "El mínimo 0 km del ítem " +
          position +
          " no puede superar el precio 0 km"
        );
      }
      const usedMonthly = toNumber(item.price_used_monthly);
      const usedMin = toNumber(item.price_used_min);
      if (usedMin !== null && usedMonthly === null) {
        return "El mínimo de usado requiere el precio de usado.";
      }
      if (usedMin !== null && usedMonthly !== null && usedMin > usedMonthly) {
        return "El mínimo de usado no puede superar el precio de usado.";
      }
      if (usedMonthly !== null && usedMonthly < 0) {
        return "El precio de usado del ítem " + position + " no puede ser negativo";
      }
      if (!item.versions.length) {
        return "El ítem " + position + " necesita al menos una versión";
      }
      for (let i = 0; i < item.versions.length; i++) {
        const version = item.versions[i];
        if (seen[version.version_id]) {
          return "La versión " + version.label + " está repetida en la lista.";
        }
        seen[version.version_id] = true;
      }
    }
    return null;
  };

  const handleSubmit = () => {
    const items = list.items.filter(itemHasContent);
    const error = validatePayload(items);
    if (error) {
      setSnackbar({
        open: true,
        message: error,
        severity: "error"
      });
      return;
    }

    const payload = {
      name: list.name,
      status: list.status,
      valid_from: list.valid_from || null,
      valid_to: list.valid_to || null,
      adjustment_pct: toNumber(list.adjustment_pct),
      used_max_year: toNumber(list.used_max_year),
      notes: list.notes || null,
      items: items.map(item => ({
        label: item.label || null,
        km_included_monthly: toNumber(item.km_included_monthly),
        km_excess_price: toNumber(item.km_excess_price),
        price_new_monthly: toNumber(item.price_new_monthly),
        price_new_min: toNumber(item.price_new_min),
        price_used_monthly: toNumber(item.price_used_monthly),
        price_used_min: toNumber(item.price_used_min),
        version_ids: item.versions.map(version => version.version_id)
      }))
    };

    const token = localStorage.getItem("userToken");
    const request =
      id != 0
        ? axios.patch(api.flexPriceLists().patch(id), payload, {
            headers: { Authorization: `Bearer ${token}` }
          })
        : axios.post(api.flexPriceLists().post(), payload, {
            headers: { Authorization: `Bearer ${token}` }
          });

    setBackdrop({ open: true, message: "Guardando lista..." });
    request
      .then(res => {
        if (id != 0) {
          setSnackbar({
            open: true,
            message: "Lista guardada con exito",
            severity: "success"
          });
          setBackdrop({ open: true, message: "Refrescando lista..." });
          getList(id).then(() => setBackdrop({ open: false, message: "" }));
          return;
        }
        const created = unwrap(res.data) || {};
        const newId = created.id;
        window.location.href = newId
          ? "/bookings/flex-price-lists/" + newId
          : "/bookings/flex-price-lists";
      })
      .catch(err => {
        const errors =
          err.response && err.response.data ? err.response.data.errors : null;
        let errorMsg = "";
        if (errors) {
          Object.keys(errors).forEach(key => {
            errorMsg += errors[key];
          });
        }
        setSnackbar({
          open: true,
          message: errorMsg || "Ha ocurrido un error al guardar la lista",
          severity: "error"
        });
        setBackdrop({ open: false, message: "" });
      });
  };

  const statusOptions = statuses.slice();
  if (
    list.status &&
    !statusOptions.some(option => option.value === list.status)
  ) {
    statusOptions.unshift({ value: list.status, label: list.status });
  }

  if (loading) {
    return (
      <Container fluid className="main-content-container px-4">
        <CircularProgress className="mt-4" />
      </Container>
    );
  }

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Snackbar
        open={snackbar.open}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        className="alert-fix"
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Backdrop
        open={backdrop.open}
        style={{ zIndex: 10000, color: "#3f51b5" }}
      >
        <Typography className="ml-2" variant="h5" color="primary">
          {backdrop.message}
        </Typography>
      </Backdrop>
      <div className="pt-4 pb-3">
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          {id == 0
            ? "Nueva lista de precios Flex"
            : "Lista de precios Flex " + id}
        </Typography>
      </div>
      <Row>
        <Col lg={id == 0 ? 12 : 9}>
          <Card className="mb-3">
            <CardBody>
              <Typography
                style={{ fontSize: "0.8rem", fontWeight: 600, marginBottom: 8 }}
              >
                Datos de la lista
              </Typography>
              <Row>
                <Col md="6" className="mb-2">
                  <TextField
                    id="name"
                    label="Nombre"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={list.name}
                    onChange={e => setList({ ...list, name: e.target.value })}
                    InputLabelProps={fieldLabelProps}
                    InputProps={fieldInputProps}
                  />
                </Col>
                <Col md="3" className="mb-2">
                  <TextField
                    id="status"
                    select
                    label="Estado"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={list.status}
                    onChange={e => setList({ ...list, status: e.target.value })}
                    InputLabelProps={fieldLabelProps}
                    InputProps={fieldInputProps}
                  >
                    {statusOptions.map(option => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                        style={{ fontSize: "0.75rem" }}
                      >
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Col>
                <Col md="3" className="mb-2">
                  <NumberFormat
                    id="adjustment_pct"
                    label="Ajuste"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={list.adjustment_pct}
                    onValueChange={values =>
                      setList({ ...list, adjustment_pct: values.value })
                    }
                    decimalSeparator=","
                    suffix=" %"
                    customInput={TextField}
                    InputLabelProps={fieldLabelProps}
                    InputProps={fieldInputProps}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="3" className="mb-2">
                  <TextField
                    id="valid_from"
                    label="Vigente desde"
                    type="date"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={list.valid_from}
                    onChange={e =>
                      setList({ ...list, valid_from: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                      style: { fontSize: "0.75rem" }
                    }}
                    InputProps={fieldInputProps}
                  />
                </Col>
                <Col md="3" className="mb-2">
                  <TextField
                    id="valid_to"
                    label="Vigente hasta"
                    type="date"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={list.valid_to}
                    onChange={e =>
                      setList({ ...list, valid_to: e.target.value })
                    }
                    InputLabelProps={{
                      shrink: true,
                      style: { fontSize: "0.75rem" }
                    }}
                    InputProps={fieldInputProps}
                  />
                </Col>
                <Col md="6" className="mb-2">
                  <TextField
                    id="used_max_year"
                    label="Año máximo usado"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    value={list.used_max_year}
                    onChange={e =>
                      setList({ ...list, used_max_year: e.target.value })
                    }
                    helperText="Los vehículos de este año o anteriores se cotizan como usados."
                    FormHelperTextProps={{
                      style: { fontSize: "0.7rem", marginLeft: 0 }
                    }}
                    InputLabelProps={fieldLabelProps}
                    InputProps={fieldInputProps}
                    inputProps={{
                      inputMode: "numeric",
                      style: { fontSize: "0.75rem" }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <TextField
                    id="notes"
                    label="Notas"
                    variant="outlined"
                    fullWidth
                    margin="dense"
                    multiline
                    rows={2}
                    value={list.notes}
                    onChange={e => setList({ ...list, notes: e.target.value })}
                    InputLabelProps={fieldLabelProps}
                    InputProps={fieldInputProps}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>

          <div className="d-flex justify-content-between align-items-center mb-2 px-1">
            <Typography style={{ fontSize: "0.8rem", fontWeight: 600 }}>
              Ítems
            </Typography>
            <Button
              outline
              size="sm"
              theme="accent"
              onClick={() =>
                setList({ ...list, items: list.items.concat(emptyItem()) })
              }
            >
              Agregar ítem
            </Button>
          </div>

          {list.items.length === 0 && (
            <Card className="mb-3">
              <CardBody className="text-center" style={{ color: "#6c757d" }}>
                Esta lista todavía no tiene ítems.
              </CardBody>
            </Card>
          )}

          {list.items.map((item, index) => (
            <Card key={item.key} className="mb-3">
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <Typography style={{ fontSize: "0.85rem", fontWeight: 600 }}>
                    Ítem {index + 1}
                    {item.label ? " · " + item.label : ""}
                  </Typography>
                  <Button
                    outline
                    size="sm"
                    theme="danger"
                    onClick={() =>
                      setList({
                        ...list,
                        items: list.items.filter(row => row.key !== item.key)
                      })
                    }
                  >
                    Quitar
                  </Button>
                </div>
                <Row>
                  <Col md="6">
                    <TextField
                      id={"label-" + index}
                      label="Etiqueta"
                      variant="outlined"
                      fullWidth
                      margin="dense"
                      value={item.label}
                      onChange={e => updateItem(index, "label", e.target.value)}
                      InputLabelProps={fieldLabelProps}
                      InputProps={fieldInputProps}
                    />
                  </Col>
                  <Col md="3">
                    <TextField
                      id={"km-" + index}
                      label="Km incluidos / mes"
                      variant="outlined"
                      fullWidth
                      margin="dense"
                      value={item.km_included_monthly}
                      onChange={e =>
                        updateItem(index, "km_included_monthly", e.target.value)
                      }
                      InputLabelProps={fieldLabelProps}
                      InputProps={fieldInputProps}
                      inputProps={{
                        inputMode: "numeric",
                        style: { fontSize: "0.75rem" }
                      }}
                    />
                  </Col>
                  <Col md="3">
                    <MoneyField
                      id={"km-excess-" + index}
                      label="Precio km extra"
                      value={item.km_excess_price}
                      onChange={value =>
                        updateItem(index, "km_excess_price", value)
                      }
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md="6">
                    <Typography
                      style={{
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        color: "#5a6169"
                      }}
                    >
                      0 km
                    </Typography>
                    <Row>
                      <Col xs="6">
                        <MoneyField
                          id={"price-new-" + index}
                          label="Precio mensual"
                          value={item.price_new_monthly}
                          onChange={value =>
                            updateItem(index, "price_new_monthly", value)
                          }
                        />
                      </Col>
                      <Col xs="6">
                        <MoneyField
                          id={"price-new-min-" + index}
                          label="Mínimo"
                          value={item.price_new_min}
                          onChange={value =>
                            updateItem(index, "price_new_min", value)
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md="6">
                    <Typography
                      style={{
                        fontSize: "0.7rem",
                        fontWeight: 600,
                        color: "#5a6169"
                      }}
                    >
                      Usado
                    </Typography>
                    <Row>
                      <Col xs="6">
                        <MoneyField
                          id={"price-used-" + index}
                          label="Precio mensual"
                          value={item.price_used_monthly}
                          onChange={value =>
                            updateItem(index, "price_used_monthly", value)
                          }
                        />
                      </Col>
                      <Col xs="6">
                        <MoneyField
                          id={"price-used-min-" + index}
                          label="Mínimo"
                          value={item.price_used_min}
                          onChange={value =>
                            updateItem(index, "price_used_min", value)
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className="mt-3">
                  <Typography style={{ fontSize: "0.75rem", fontWeight: 600 }}>
                    Versiones
                  </Typography>
                  <Typography
                    style={{
                      fontSize: "0.7rem",
                      color: "#6c757d",
                      marginBottom: 8
                    }}
                  >
                    Escribí al menos 3 letras. Una versión no puede repetirse en
                    la lista.
                  </Typography>
                  <div className="mb-2">
                    {item.versions.length === 0 ? (
                      <Typography style={{ fontSize: "0.75rem", color: "#6c757d" }}>
                        Sin versiones
                      </Typography>
                    ) : (
                      item.versions.map(version => (
                        <Chip
                          key={version.version_id}
                          label={version.label}
                          size="small"
                          onDelete={() =>
                            removeVersion(index, version.version_id)
                          }
                          style={{
                            marginRight: 6,
                            marginBottom: 6,
                            fontSize: "0.75rem"
                          }}
                        />
                      ))
                    )}
                  </div>
                  <Autocomplete
                    key={"version-" + item.key + "-" + item.versions.length}
                    id={"versions-" + index}
                    getOptionLabel={option =>
                      option.full_name || versionLabel(option) || ""
                    }
                    options={versions.options}
                    loading={versions.loading}
                    onInputChange={handleSearchVersions}
                    onChange={(e, value) => addVersion(index, value)}
                    renderOption={option => (
                      <Typography style={{ fontSize: "0.75rem" }}>
                        {option.full_name || versionLabel(option)}
                      </Typography>
                    )}
                    ListboxProps={{ style: { fontSize: "0.75rem" } }}
                    noOptionsText={
                      <Typography style={{ fontSize: "0.75rem" }}>
                        {versions.loading
                          ? "Buscando"
                          : "Sin resultados"}
                      </Typography>
                    }
                    includeInputInList
                    style={{ maxWidth: 480 }}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label="Buscar versión"
                        variant="outlined"
                        margin="dense"
                        placeholder="Mínimo 3 letras"
                        InputLabelProps={{
                          ...params.InputLabelProps,
                          style: { fontSize: "0.75rem" }
                        }}
                        InputProps={{
                          ...params.InputProps,
                          style: { fontSize: "0.75rem" },
                          endAdornment: (
                            <React.Fragment>
                              {versions.loading ? (
                                <CircularProgress color="inherit" size={16} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </React.Fragment>
                          )
                        }}
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: "0.75rem" }
                        }}
                      />
                    )}
                  />
                </div>
              </CardBody>
            </Card>
          ))}

          <div className="d-flex align-items-center mt-2 mb-4">
            <Button
              primary
              theme="accent"
              className="mr-2"
              onClick={handleSubmit}
            >
              Guardar
            </Button>
            <Button
              outline
              theme="secondary"
              onClick={() => {
                window.location.href = "/bookings/flex-price-lists";
              }}
            >
              Volver
            </Button>
          </div>
        </Col>
        {id != 0 && (
          <Col lg={3}>
            <Card className="mb-3">
              <CardBody className="p-0">
                <ListGroup flush>
                  <ListGroupItem
                    className="px-3 py-2"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <i
                      className="material-icons mr-1"
                      style={{ fontSize: 16, verticalAlign: "text-bottom" }}
                    >
                      flag
                    </i>
                    {statusLabel(list.status)}
                  </ListGroupItem>
                  <ListGroupItem
                    className="px-3 py-2"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <i
                      className="material-icons mr-1"
                      style={{ fontSize: 16, verticalAlign: "text-bottom" }}
                    >
                      calendar_today
                    </i>
                    {formatDate(list.valid_from)}
                    {list.valid_to ? " — " + formatDate(list.valid_to) : ""}
                  </ListGroupItem>
                  <ListGroupItem
                    className="px-3 py-2"
                    style={{ fontSize: "0.8rem" }}
                  >
                    {list.items.length}{" "}
                    {list.items.length === 1 ? "ítem" : "ítems"}
                  </ListGroupItem>
                  <ListGroupItem className="px-3 py-2">
                    <a
                      href={"/bookings/flex-price-lists/" + id + "/stock"}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        fontSize: "0.8rem"
                      }}
                    >
                      <i
                        className="material-icons mr-1"
                        style={{ fontSize: 16, verticalAlign: "text-bottom" }}
                      >
                        directions_car
                      </i>
                      Ver stock
                    </a>
                  </ListGroupItem>
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        )}
      </Row>
    </Container>
  );
};

export default FlexPriceList;
